import { ColorEnum } from '@/constants/color'
import Button from '@/features/ui/buttons/components/Button'
import ArrowIcon from '@/features/ui/icons/components/ArrowIcon'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'

interface BackButtonProps {
    onBack: () => void
}

const BackButton: FC<BackButtonProps> = ({ onBack }) => {
    const { t } = useTranslation()

    return (
        <Button
            type="naked"
            size="small"
            onPress={onBack}
            FrontIcon={ArrowIcon}
            style={styles.backButton}
            textStyle={styles.backButtonText}
        >
            {t('settings.printers.printerConfiguration.backToOverview').toUpperCase()}
        </Button>
    )
}

const styles = StyleSheet.create({
    backButton: {
        alignSelf: 'flex-start',
    },
    backButtonText: {
        color: ColorEnum.GRAY_900,
    },
})

export default BackButton
